import tippy from 'tippy.js';

function ToolTips() {
	const allTooltips = document.querySelectorAll('[data-tooltip]');

	const allTippyInstances = [];

	allTooltips.forEach(tooltip => {
		const template = document.querySelector(
			`[data-tooltip-target="${tooltip.dataset.tooltip}"`
		);

		const tip = tippy(tooltip, {
			allowHTML: true,
			content: template.innerHTML,
			delay: [70, 0],
		});
		allTippyInstances.push(tip);
	});

	return () => {
		allTippyInstances.forEach(tip => tip.destroy());
	};
}

export default ToolTips;
